import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgXCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.12 11.12 15.236 14l2.882 2.88a.873.873 0 0 1 0 1.24.875.875 0 0 1-1.238 0L14 15.236l-2.88 2.882a.875.875 0 0 1-1.24-1.238L12.764 14l-2.882-2.88a.876.876 0 0 1 1.238-1.24L14 12.764l2.88-2.882a.876.876 0 0 1 1.24 1.238ZM25.374 14A11.375 11.375 0 1 1 14 2.625 11.387 11.387 0 0 1 25.375 14Zm-1.75 0A9.625 9.625 0 1 0 14 23.625 9.636 9.636 0 0 0 23.625 14Z" />
  </svg>
);
export default SvgXCircle;
